import { IconButton, Stack, Typography } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';

export default function HeaderModal({ headerTitle, close }: { headerTitle: string, close: Function }) {
  return (
    <header className="modal-card-head">
      <Stack
        width='100%'
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
      >
        <Typography width='100%' textAlign='center' variant="h5" color='textSecondary'>{headerTitle}</Typography>
        <IconButton >
          <CancelIcon
            color="error"
            onClick={() => close()}
          />
        </IconButton>
      </Stack>
    </header>
  );
}
